'use client';
import { useState } from 'react';
import { Box, Button, Flex, Link, Text, Image } from '@skin-seoul/design-system';
import { getMediaOrigin } from '@skin-seoul/service';

import { SkinSocietyBenefitsModal } from '../../SkinSocietyBenefitsModal';

// Image path constants
const LOYALTY_IMAGE_PATHS = {
  MOBILE_SIGN_UP_GIFT: '/loyalty/mobile-sign-up-gift.png',
} as const;

export const LoyaltyPointsSignUpBannerMobile = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewBenefits = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Box position="relative" width="100%" borderRadius="8px" overflow="hidden">
        {/* Base gradient background */}
        <Box position="absolute" inset="0" bgGradient="to-r" gradientFrom="#311275" gradientTo="#754DCC" />

        {/* Decorative gift icon */}

        {/* Content layer */}
        <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" p={3} zIndex={1}>
          {/* Left Side - Text Content */}
          <Box position="absolute" left="0px" color="primary.100" zIndex={0}>
            <Image
              src={`${getMediaOrigin()}${LOYALTY_IMAGE_PATHS.MOBILE_SIGN_UP_GIFT}`}
              alt="Gift Icon"
              width="44px"
              height="72px"
            />
          </Box>
          <Flex direction="column" gap={1} pl="30px">
            <Box>
              <Text as="span" color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold" display="block">
                Claim All Benefits,
              </Text>
              <Text as="span" color="primary.100" textStyle="heading.h6.mobile" fontWeight="bold" display="block">
                Right here
              </Text>
            </Box>
            <Text color="primary.200" textStyle="label.small" fontWeight="medium">
              Sign up & Join SkinSociety Now!
            </Text>
          </Flex>

          {/* Right Side - Buttons */}
          <Flex direction="column" gap={3.5} alignItems="flex-start">
            <Button
              asChild
              size="sm"
              variant="primary"
              bg="white"
              color="black"
              _hover={{ bg: 'neutral.50' }}
              px={4}
              height="36px"
            >
              <Link unstyled href="/my-account/">
                Sign In
              </Link>
            </Button>
            <Box
              as="button"
              onClick={handleViewBenefits}
              color="white"
              textStyle="label.small"
              fontWeight="medium"
              textDecoration="underline"
              cursor="pointer"
              bg="transparent"
              border="none"
              _hover={{ color: 'primary.100' }}
            >
              View Benefits
            </Box>
          </Flex>
        </Flex>
      </Box>
      <SkinSocietyBenefitsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        showBottomNav={false}
        showSigninComment={true}
      />
    </>
  );
};
